import React from 'react'
// import { routepath as chb } from './routepath'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import RootLayout from "../../pages/Layout/rootLayout.js";
import Home from "../../pages/Home/Home.js";
import Experience from '../../pages/Experience/Experience.jsx';
import Stay from '../../pages/Stay/Stay.jsx';
import Learning from '../../pages/Learning/Learning.jsx';
import FamilyRetreats from '../../pages/Family-Retreats/FamilyRetreats.jsx';
import Community from '../../pages/Community/Community.jsx';
import Ourstory from '../../pages/Ourstory/Ourstory.jsx';
import HornbillCollective from '../../pages/Hornbill-Collective/HornbillCollective.jsx';
import Contact from '../../pages/Contact-us/Contact.jsx';
import Gallery from '../../pages/Gallery/Gallery.jsx';
import ScrollToTop from '../services/ScrollToTop.jsx';

function AppRoute() {
    return (
        <>
            <BrowserRouter>
            <ScrollToTop />
                <Routes>
                    <Route element={<RootLayout />}>
                        <Route path='/' element={<Home />}></Route>
                        <Route path='/experience' element={<Experience />}></Route>
                        <Route path='/stay' element={<Stay />}></Route>
                        <Route path='/learning' element={<Learning />}></Route>
                        <Route path='/family-retreats' element={<FamilyRetreats />}></Route>
                        <Route path='/community-Conservation' element={<Community />}></Route>
                        <Route path='/our-story' element={<Ourstory />}></Route>
                        {/* <Route path='/hornbill-collective' element={<HornbillCollective />}></Route> */}
                        <Route path='/contact-us' element={<Contact />}></Route>
                        <Route path='/gallery' element={<Gallery />}></Route>
                    </Route>
                </Routes>
            </BrowserRouter>
        </>
    )
}

export default AppRoute